import { createSlice } from "@reduxjs/toolkit";
import { AdditionalRequestState } from "../dataTypes";
import { fileSliceName } from "./dataTypes";
import { fileAdapter } from "./fileAdapter";
import { addFetchFileReducers } from "./reducers/fetchFile";

const slice = createSlice({
  name: fileSliceName,
  initialState: fileAdapter.getInitialState<AdditionalRequestState>({}),
  reducers: {},
  extraReducers: builder => {
    addFetchFileReducers(builder);
  },
});

const { reducer } = slice;

export default reducer;
